<script>
import Datatable from "@/router/layouts/table-datatable";
import Pagination from "@/router/layouts/table-pagination";
import ModalImportProfesi from "../modal-import-profesi.vue";
import ModalFormMasterProfesi from "./modal-form-master-profesi.vue";
import axios from "axios";
import Swal from "sweetalert2";
import _ from "lodash";

export default {
  components: {
    Datatable,
    Pagination,
    ModalImportProfesi,
    ModalFormMasterProfesi,
  },
  data() {
    let sortOrders = []; // select sortOrder
    let columns = [
      {
        width: "50px",
        label: "No",
        name: "-",
      },
      {
        width: "auto",
        label: "ID",
        name: "id_mprofesi",
      },
      {
        width: "auto",
        label: "Kode Profesi",
        name: "kode_profesi",
      },
      {
        width: "auto",
        label: "Nama Profesi",
        name: "nama_profesi",
      },
      {
        width: "auto",
        label: "Kode Dahan Profesi",
        name: "dp_kode",
      },
      {
        width: "auto",
        label: "Dahan Profesi",
        name: "dp_name",
      },
      {
        width: "auto",
        label: "Kode Pohon Profesi",
        name: "ph_kode",
      },
      {
        width: "auto",
        label: "Pohon Profesi",
        name: "ph_name",
      },
      {
        width: "auto",
        label: "Kode Pohon Bisnis",
        name: "pb_kode",
      },
      {
        width: "auto",
        label: "Pohon Bisnis",
        name: "pb_name",
      },
      // {
      //   width: "auto",
      //   label: "Status",
      //   name: "status",
      // },
      {
        width: "170px",
        label: "Aksi",
        name: "-",
      },
    ];
    const menu = "Master Profesi";

    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });

    return {
      title: menu,
      showModal: false,
      showModalImport: false,
      titleModal: "",
      typeModal: "add",
      loadingTable: false,
      columns: columns,
      sortKey: "id_mprofesi",
      sortOrders: sortOrders,
      currentTablePage: "",
      tableData: [],
      tableFilter: {
        page: 1,
        draw: 0,
        per_page: 10,
        search: "",
        column: "id_mprofesi",
        dir: "desc",
        kode_profesi: "",
        nama_profesi: "",
        kode_dahan_profesi: "",
        dahan_profesi: "",
        kode_pohon_profesi: "",
        pohon_profesi: "",
        kode_pohon_bisnis: "",
        pohon_bisnis: "",
        filter_status: "ENABLE", // untuk filtering data
      },
      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
        links: "",
      },
    };
  },
  methods: {
    async getDataTable(resetPage = true) {
      this.tableFilter.page = resetPage ? 1 : this.tableFilter.page;
      this.loadingTable = true;
      this.tableData = [];
      const config = {
        method: "get",
        url: `${process.env.VUE_APP_BACKEND_URL_VERSION}master/profesi`,
        params: this.tableFilter,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      };
      await axios(config)
        .then((response) => {
          if (response.data.meta.code == 200) {
            this.tableData = response.data.data.data;
            this.currentTablePage = response.data.data.current_page;
            this.loadingTable = false;
            this.configPagination(response.data.data);
          } else {
            this.loadingTable = false;
            Swal.fire({
              icon: "error",
              title: "Error",
              text: response.data.meta.message,
            });
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          this.loadingTable = false;
        });
    },
    configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
      this.pagination.links = data.links;
    },
    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableFilter.column = key;
      this.tableFilter.dir = this.sortOrders[key] === 1 ? "asc" : "desc";
      this.getDataTable();
    },
    getIndex(array, key, value) {
      return array.findIndex((i) => i[key] == value);
    },
    toPage(url) {
      let link = new URLSearchParams(url);
      this.tableFilter.page = link.get("page");
      // this.tableFilter.per_page = link.get('per_page');
      this.getDataTable(false);
    },
    importData() {
      this.showModalImport = true;
    },
    exportData() {
      let params = new URLSearchParams(this.tableFilter).toString();
      window.open(
        process.env.VUE_APP_BACKEND_URL_VERSION +
          "export-excel/profesi?" +
          params
      );
    },

    addData() {
      this.titleModal = "Tambah Data Profesi";
      this.typeModal = "add";
      this.dataModal = null;
      this.showModal = true;
    },
    editData(row) {
      this.titleModal = "Edit Data Profesi";
      this.typeModal = "edit";
      this.dataModal = row;
      this.showModal = true;
    },
    updateStatus(row, status) {
      row.status = status;
      const label = status === "ENABLE" ? "Aktif" : "Tidak Aktif";
      Swal.fire({
        icon: "question",
        title: "Apakah Anda yakin mengubah status data ini menjadi " + label + " ?",
        // text: "Data yang terhapus tidak dapat dipulihkan kembali!",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `Iya`,
        denyButtonText: `Tidak`,
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: '<i class="fas fa-spinner fa-spin"></i>',
            text: "Loading...",
            showConfirmButton: false,
            allowOutsideClick: false,
          });

          axios({
            method: "put",
            url:
              process.env.VUE_APP_BACKEND_URL_VERSION +
              "master/profesi/" +
              row.id_mprofesi,
            data: row,
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + localStorage.access_token,
            },
          }).then((response) => {
            let response_data = response.data;
            if (response_data.meta.code != "200") {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: response_data.data.message,
              });
            } else {
              Swal.fire({
                icon: "success",
                title: "Berhasil",
                text: "Data berhasil dihapus.",
                timer: 2000,
                timerProgressBar: true,
                showCancelButton: false,
                showConfirmButton: false,
              }).then((result) => {
                if (result.dismiss) {
                  this.getDataTable();
                }
              });
            }
          });
        } else {
          row.status = status === "ENABLE" ? "DISABLE" : "ENABLE"; // Revert status if not confirmed
          Swal.close();
        }
      });
    },
    deleteData(row) {
      Swal.fire({
        icon: "question",
        title: "Apakah Anda yakin menghapus data ini?",
        text: "Data yang terhapus tidak dapat dipulihkan kembali!",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `Iya`,
        denyButtonText: `Tidak`,
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: '<i class="fas fa-spinner fa-spin"></i>',
            text: "Loading...",
            showConfirmButton: false,
            allowOutsideClick: false,
          });

          axios({
            method: "delete",
            url:
              process.env.VUE_APP_BACKEND_URL_VERSION +
              "master/profesi/" +
              row.id_mprofesi,
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + localStorage.access_token,
            },
          }).then((response) => {
            let response_data = response.data;
            if (response_data.meta.code != "200") {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: response_data.data.message,
              });
            } else {
              Swal.fire({
                icon: "success",
                title: "Berhasil",
                text: "Data berhasil dihapus.",
                timer: 2000,
                timerProgressBar: true,
                showCancelButton: false,
                showConfirmButton: false,
              }).then((result) => {
                if (result.dismiss) {
                  this.getDataTable();
                }
              });
            }
          });
        } else {
          Swal.close();
        }
      });
    },
  },
  mounted() {
    this.getDataTable();
    this.filterData = _.debounce(this.getDataTable.bind(this), 500);
  },
};
</script>
<template>
  <div class="row">
    <div class="col-12">
      <div class="row">
        <div class="d-flex justify-content-between">
          <div class="card-title">Master Profesi</div>
          <div class="d-flex gap-2">
            <button class="btn btn-success btn-sm" @click="exportData()">
              <i class="fa fa-file-excel me-1"></i> Export Excel
            </button>
            <button class="btn btn-info btn-sm" @click="importData()">
              <i class="fa fa-file-excel me-1"></i> Import Excel
            </button>
            <!-- <button class="btn btn-success btn-sm">
              <i class="fa fa-file-excel me-1"></i> Import Excel
            </button> -->
            <button class="btn btn-primary btn-sm" @click="addData()">
              <i class="fa fa-plus me-1"></i> Tambah Data
            </button>
          </div>
        </div>
        <div class="col-12">
          <hr />
          <div class="row">
            <div class="col-md-4 mt-2">
              <label for="filterKodeProfesi">Kode Profesi</label>
              <input
                class="form-control"
                v-model="tableFilter.kode_profesi"
                placeholder="Filter Kode Profesi..."
                @input="filterData"
              />
            </div>
            <div class="col-md-4 mt-2">
              <label for="filterNamaProfesi">Nama Profesi</label>
              <input
                class="form-control"
                v-model="tableFilter.nama_profesi"
                placeholder="Filter Nama Profesi..."
                @input="filterData"
              />
            </div>
            <div class="col-md-4 mt-2">
              <label for="filterKodeDahanProfesi">Kode Dahan Profesi</label>
              <input
                class="form-control"
                v-model="tableFilter.kode_dahan_profesi"
                placeholder="Filter Kode Dahan Profesi..."
                @input="filterData"
              />
            </div>
            <div class="col-md-4 mt-2">
              <label for="filterDahanProfesi">Dahan Profesi</label>
              <input
                class="form-control"
                v-model="tableFilter.dahan_profesi"
                placeholder="Filter Dahan Profesi..."
                @input="filterData"
              />
            </div>
            <div class="col-md-4 mt-2">
              <label for="filterKodePohonProfesi">Kode Pohon Profesi</label>
              <input
                class="form-control"
                v-model="tableFilter.kode_pohon_profesi"
                placeholder="Filter Kode Pohon Profesi..."
                @input="filterData"
              />
            </div>
            <div class="col-md-4 mt-2">
              <label for="filterPohonProfesi">Pohon Profesi</label>
              <input
                class="form-control"
                v-model="tableFilter.pohon_profesi"
                placeholder="Filter Pohon Profesi..."
                @input="filterData"
              />
            </div>
            <div class="col-md-4 mt-2">
              <label for="filterKodePohonBisnis">Kode Pohon Bisnis</label>
              <input
                class="form-control"
                v-model="tableFilter.kode_pohon_bisnis"
                placeholder="Filter Kode Pohon Bisnis..."
                @input="filterData"
              />
            </div>
            <div class="col-md-4 mt-2">
              <label for="filterPohonBisni">Pohon Bisnis</label>
              <input
                class="form-control"
                v-model="tableFilter.pohon_bisnis"
                placeholder="Filter Pohon Bisnis..."
                @input="filterData"
              />
            </div>
            <div class="col-md-4 mt-2">
              <label for="filterStatus">Status</label>
              <select
                class="form-select"
                v-model="tableFilter.filter_status"
                @change="filterData"
              >
                <option value="ENABLE">Aktif</option>
                <option value="DISABLE">Tidak Aktif</option>
              </select>
            </div>
          </div>
          <hr />
        </div>
        <datatable
          :columns="columns"
          :sortKey="sortKey"
          :sortOrders="sortOrders"
          @sort="sortBy"
        >
          <tbody>
            <tr v-if="loadingTable">
              <td colspan="99" class="text-center">
                <i class="fas fa-spinner fa-spin"></i> Loading...
              </td>
            </tr>
            <tr v-else-if="tableData.length == 0">
              <td colspan="99" class="text-center">Data tidak tersedia</td>
            </tr>
            <tr v-else v-for="(row, key) in tableData" :key="key">
              <td>
                <span v-if="key + 1 == 10"> {{ currentTablePage }}0. </span>
                <span v-else>
                  {{
                    currentTablePage - 1 != 0
                      ? currentTablePage - 1 + `${key + 1}`
                      : `${key + 1}`
                  }}.
                </span>
              </td>
              <td>{{ row.id_mprofesi }}</td>
              <td>{{ row.kode_profesi ?? "-" }}</td>
              <td>{{ row.nama_profesi ?? "-" }}</td>
              <td>{{ row.dp_kode ?? "-" }}</td>
              <td>{{ row.dp_name ?? "-" }}</td>
              <td>{{ row.ph_kode ?? "-" }}</td>
              <td>{{ row.ph_name ?? "-" }}</td>
              <td>{{ row.pb_kode ?? "-" }}</td>
              <td>{{ row.pb_name ?? "-" }}</td>
              <td class="text-center">
                <div class="btn-group btn-group-sm">
                  <button
                    v-if="row.status === 'ENABLE'"
                    class="btn btn-warning btn-sm"
                    @click="editData(row)"
                  >
                    <i class="fa fa-edit"></i> Edit
                  </button>
                  <button
                    v-if="row.status === 'ENABLE'"
                    class="btn btn-danger btn-sm"
                    @click="updateStatus(row, 'DISABLE')"
                  >
                    <i class="fa fa-trash"></i> Disable
                  </button>
                  <button
                    v-if="row.status === 'DISABLE'"
                    class="btn btn-success btn-sm"
                    @click="updateStatus(row, 'ENABLE')"
                  >
                    <i class="fa fa-trash-restore"></i> Enable
                  </button>
                  <button
                    v-if="row.status === 'DISABLE'"
                    class="btn btn-danger btn-sm"
                    @click="deleteData(row)"
                  >
                    <i class="fa fa-trash"></i> Hapus
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </datatable>
      </div>
      <pagination :pagination="pagination" @to-page="toPage" />
    </div>
  </div>

  <b-modal v-model="showModal" :title="titleModal" hide-footer>
    <ModalFormMasterProfesi
      :typeTrans="typeModal"
      :dataProfesi="dataModal"
      @submitForm="
        getDataTable();
        showModal = false;
      "
    ></ModalFormMasterProfesi>
  </b-modal>
  <b-modal v-model="showModalImport" title="Import Data Profesi" hide-footer>
    <ModalImportProfesi
      :module="'profesi'"
      @refreshTable="
        showModalImport = false;
        getDataTable();
      "
    />
  </b-modal>
</template>
